const verify = {
  /**
   * 验证函数
   * @param str 待验证字符串
   * @param pat 验证类型，number，digits，email，mobile
   * @returns
   */
  verify: function(str, pat) {
    return this.verifySelf(str, this.patterns[pat])
  },
  /**
   * 验证函数
   * @param str 待验证字符串
   * @param thePat 验证正则表达式
   * @returns
   */
  verifySelf: function(str, thePat) {
    if (thePat.test(str)) {
      return true
    } else {
      return false
    }
  },
  patterns: {
    // 验证数字
    number: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/,
    // 验证正整数
    digits: /^\d+$/,
    // 验证由26个英文字母组成的字符串
    letter: /^[A-Za-z]+$/,
    // 验证由数字和26个英文字母组成的字符串
    letterAndNumber: /^[A-Za-z0-9]+$/,
    // 验证EMAIL
    email: /^[.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    // 验证手机号
    mobile: /^((\(\d{2,3}\))|(\d{3}-))?1\d{10}$/,
    // 验证IP
    ip: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){3}$/,
    // 验证url
    url: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
    // 验证日期格式2009-07-13
    date: /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[1-2]\d|3[0-1])$/,
    // 验证时间格式16:55:39
    time: new RegExp('^([0-1]\\d|2[0-3]):[0-5]\\d:[0-5]\\d$')
  }
}

export {
  verify
}



// WEBPACK FOOTER //
// ./src/commons/utils/Validate.js